import { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
    Text,
    Switch,
    Flex
} from "@chakra-ui/react";
import { InfoIconOutlineYellow } from "../../../styles/icons/InfoIconOutlineYellow";
import { useParams } from "react-router-dom";
import { showToast } from "../../../utils/toast";
import { useFeatureToggles } from "../../../hooks/useFeatureToggles";

export function ModalCreditCard() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [defaultStatus] = useState<boolean>(false);
    const [modalType, setModalType] = useState<"activate" | "deactivate" | null>(null);
    const { loadInitialData, postFeatureToggles } = useFeatureToggles();
    const [isFeatureLoading, setIsFeatureLoading] = useState(false);
    const [initialData, setInitialData] = useState<any[]>([]);
    const { id } = useParams();

    

    async function getInitialData() {
        try {
            setIsFeatureLoading(true);
            const response = await loadInitialData();
            const betaSellers = response.data
                .filter((item: any) => item.name === "view_seller_banking_cards")
                .flatMap((item: any) => item.betaSellers);
            setInitialData(betaSellers);
        } catch (error) {
            error?.response?.data?.errors?.map((error:any) => (
                showToast({
                    type: "error",
                    message: `${error?.code} - ${error?.description}`
                })
            ));
        } finally {
            setIsFeatureLoading(false);
        }
    }
    async function handleAddSellerToggle() {
        try {
            const updatedBetaSellers = [...initialData];
            updatedBetaSellers.push(Number(id));
            await postFeatureToggles({
                toggleName: "view_seller_banking_cards",
                sellerIds: updatedBetaSellers
            });
            setInitialData(updatedBetaSellers);
            showToast({
                type: "success",
                message: "Tela de cartão de crédito ativada com sucesso"
            });
        } catch (error) {
            console.error(error);
        } finally {
            handleCloseModal();
        }
    }
    async function handleRemoveSellerToggle() {
        try {
            const updatedBetaSellers = [...initialData];
            updatedBetaSellers.splice(updatedBetaSellers.indexOf(Number(id)), 1);
            await postFeatureToggles({
                toggleName: "view_seller_banking_cards",
                sellerIds: updatedBetaSellers
            });
            setInitialData(updatedBetaSellers);
            showToast({
                type: "success",
                message: "Tela de cartão de crédito desativada com sucesso"
            });
        } catch (error) {
            console.error(error);
        } finally {
            handleCloseModal();
        }
    }
    useEffect(() => {
        getInitialData();
        //eslint-disable-next-line
    }, []);


    const handleToggle = (e) => {
        const isChecked = e.target.checked;
        if (isChecked && !defaultStatus) {
            setModalType("activate");
        } else if (!isChecked) {
            setModalType("deactivate");
        } else {
            setModalType(null);
        }
        onOpen();
    };

    const handleCloseModal = () => {
        setModalType(null);
        onClose();
    };

    return (
        <>
            <Switch
                id="creditCard"
                isChecked={initialData.includes(Number(id))}
                size="sm"
                sx={{
                    "& .chakra-switch__track": { backgroundColor: "gray.300" },
                    "& .chakra-switch__track[data-checked]": { backgroundColor: "red.500" },
                    "& .chakra-switch__thumb": { backgroundColor: "white" }
                }}
                onChange={handleToggle}
                isDisabled={isFeatureLoading}
            />

            <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={handleCloseModal}>
                <ModalOverlay />
                {modalType === "deactivate" && (
                    <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                        <Flex p="32px 32px 24px 32px" gap="16px">
                            <Flex>
                                <InfoIconOutlineYellow size={24} />
                            </Flex>
                            <Flex flexDirection="column" gap="8px">
                                <ModalHeader
                                    p="0"
                                    fontSize="16px"
                                    color="rgba(0, 0, 0, 0.85)"

                                >
                                    Desativar tela de cartão de crédito?
                                </ModalHeader>
                                <ModalBody
                                    p="5px 0"
                                    fontSize="14px"
                                    fontWeight="400"
                                    color="rgba(0, 0, 0, 0.85)">
                                    <Text>
                                        Ao confirmar, a tela de cartão de crédito será desativada para o seller. peça para o mesmo relogar no sistema.
                                    </Text>
                                </ModalBody>
                                <ModalFooter p="0">
                                    <Flex gap="8px">
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            h="32px"
                                            onClick={handleCloseModal}
                                            variant="outline"
                                            w="89px"
                                            borderRadius="2px"
                                            color="black"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            backgroundColor="var(--Yellow-400, rgba(198, 138, 49, 1))"
                                            color="white"
                                            w="93px"
                                            h="32px"
                                            onClick={handleRemoveSellerToggle}
                                            borderRadius="2px"

                                        >
                                            Desativar
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Flex>
                    </ModalContent>
                )}

                {modalType === "activate" && (
                    <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                        <Flex p="32px 32px 24px 32px" w="400" gap="16px" lineHeight="22px">
                            <Flex>
                                <InfoIconOutlineYellow size={24} />
                            </Flex>
                            <Flex flexDirection="column" gap="8px">
                                <ModalHeader p="0" fontSize="16px" fontWeight="600" color="rgba(0, 0, 0, 0.85)">
                                    Ativar tela de cartão de crédito
                                </ModalHeader>
                                <ModalBody p="5px 0 " fontSize="14px" fontWeight="400" color="rgba(0, 0, 0, 0.85)">
                                    <Text>
                                        Ao confirmar, a tela de cartão de crédito será ativada para o seller. peça para o mesmo relogar no sistema.
                                    </Text>
                                </ModalBody>
                                <ModalFooter p="0">
                                    <Flex gap="8px">
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            h="32px"
                                            onClick={handleCloseModal}
                                            variant="outline"
                                            w="89px"
                                            borderRadius="2px"
                                            color="black"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            backgroundColor="var(--Yellow-400, rgba(198, 138, 49, 1))"
                                            color="white"
                                            w="93px"
                                            h="32px"
                                            onClick={handleAddSellerToggle}
                                            borderRadius="2px"

                                        >
                                            Ativar
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Flex>
                    </ModalContent>
                )}
            </Modal>
        </>
    );
}
